import { Grid, Typography } from "@mui/material";
import React from "react";
import { CTBox, StyledGrid, StyledH3Heading } from "../style/StyledComponents";
import { useTheme } from "@emotion/react";

const IntroSection = () => {
  const theme = useTheme();
  return (
    <>
    <StyledGrid container>
      <StyledGrid item xs={12}>
        <StyledH3Heading>
          Free Video Notes Maker
        </StyledH3Heading>
      </StyledGrid>
      <StyledGrid item xs={12}>
        <Typography
          variant="body1"
          component="p"
          align="center"
          sx={{
            fontFamily: "Roboto, sans-serif",
            maxWidth: "600px",
            color: theme.palette.primary.main,
          }}
        >
          Create notes and bookmarks for your videos with ease. Our tool allows
          you to organize your thoughts, loop, unloop and highlight important sections, and
          revisit them effortlessly. You can also save and share your notes for
          future reference.
        </Typography>
      </StyledGrid>
    </StyledGrid>
    </>
  );
};

export default IntroSection;